import React from 'react';
import ActionButton from '../../../elements/ActionButton/ActionButton';
import emailIcon from '../../../../resources/icons/E_mail_icon.png';
import Icon from '../../../elements/icons/Icon';

function EmailLoginButton(props) {
    const { className = '', href, onClick, next, children } = props;

    return (
        <ActionButton
            className={className}
            icon={<Icon src={emailIcon} />}
            href={href}
            onClick={onClick}
            next={next}
        >
            {children}
        </ActionButton>
    );
}

export default EmailLoginButton;
